import { useAuth } from 'context/authContext'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { sendConfirmation } from 'services/auth'
import posthog from 'posthog-js'

interface ISendConfirmationPayload {
    phone_number: string
    code: string
}
const UseSendConfirmation = (
    setIsSubmit: React.Dispatch<React.SetStateAction<boolean>>,
    mobile: string
) => {
    const navigate = useNavigate()
    const { login } = useAuth()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISendConfirmationPayload) => {
            return sendConfirmation(payload)
        },
        onSuccess: (data) => {
            if (data.two_factor_token) {
                posthog.capture('login_requires_2fa')
                navigate('/auth/two-factor', {
                    state: {
                        phone_number: mobile,
                        two_factor_token: data.two_factor_token,
                    },
                })
            } else {
                // Pin the PostHog identity to the phone number at the true
                // login moment so every earlier anonymous step gets merged into
                // this person. Profile page later enriches name/email/id.
                posthog.identify(mobile, { phone_number: mobile })
                posthog.capture('login_completed', { method: 'otp' })
                toast.success('ورود با موفقیت انجام شد')
                login(data)
                navigate('/auth/profile')
            }
        },
        onError: () => {
            posthog.capture('otp_verification_failed')
            toast.error('کد وارد شده صحیح نمی باشد')
            setIsSubmit(false)
        },
    })

    return { isLoading, mutate }
}

export default UseSendConfirmation
